<div class="resume" [style.--resume-font]="font">
  <div class="header">
    <ng-container *ngIf="data?.config?.photoUrl; else showProfileDetails">
      <div class="avatar">
        <img [src]="data.config.photoUrl" alt="profile" crossorigin="anonymous" />
      </div>

      <div class="details ms-3">
        <h1 *ngIf="data?.personal_info?.fullName">
          {{ data.personal_info.fullName }}
        </h1>

        <p class="role" *ngIf="data?.targetRole" [style.color]="color">
          {{ data.targetRole }}
        </p>

        <div
          class="info"
          *ngIf="
            data?.personal_info?.email ||
            data?.personal_info?.phone ||
            data?.personal_info?.location ||
            data?.personal_info?.linkedinUrl ||
            data?.personal_info?.githubUrl
          "
        >
          <span *ngIf="data?.personal_info?.email">
            <i class="bi bi-envelope-fill"></i>
            {{ data.personal_info.email }}
          </span>

          <span *ngIf="data?.personal_info?.phone">
            <i class="bi bi-telephone-fill"></i>
            {{ data.personal_info.phone }}
          </span>

          <span *ngIf="data?.personal_info?.location">
            <i class="bi bi-geo-alt-fill"></i>
            {{ data.personal_info.location }}
          </span>

          <span *ngIf="data?.personal_info?.linkedinUrl">
            <i class="bi bi-linkedin"></i>
            {{ data.personal_info.linkedinUrl }}
          </span>

          <span *ngIf="data?.personal_info?.githubUrl">
            <i class="bi bi-github"></i>
            {{ data.personal_info.githubUrl }}
          </span>
        </div>
      </div>
    </ng-container>

    <ng-template #showProfileDetails>
      <div class="details centered-details">
        <h1 *ngIf="data?.personal_info?.fullName">
          {{ data.personal_info.fullName }}
        </h1>

        <p class="role" *ngIf="data?.targetRole" [style.color]="color">
          {{ data.targetRole }}
        </p>

        <div
          class="info"
          *ngIf="
            data?.personal_info?.email ||
            data?.personal_info?.phone ||
            data?.personal_info?.location ||
            data?.personal_info?.linkedinUrl ||
            data?.personal_info?.githubUrl
          "
        >
          <span *ngIf="data?.personal_info?.email">
            <i class="bi bi-envelope-fill"></i>
            {{ data.personal_info.email }}
          </span>

          <span *ngIf="data?.personal_info?.phone">
            <i class="bi bi-telephone-fill"></i>
            {{ data.personal_info.phone }}
          </span>

          <span *ngIf="data?.personal_info?.location">
            <i class="bi bi-geo-alt-fill"></i>
            {{ data.personal_info.location }}
          </span>

          <span *ngIf="data?.personal_info?.linkedinUrl">
            <i class="bi bi-linkedin"></i>
            {{ data.personal_info.linkedinUrl }}
          </span>

          <span *ngIf="data?.personal_info?.githubUrl">
            <i class="bi bi-github"></i>
            {{ data.personal_info.githubUrl }}
          </span>
        </div>
      </div>
    </ng-template>
  </div>

  <div
    class="divider"
    *ngIf="
      data?.summary ||
      data?.education?.length ||
      data?.projects?.length ||
      data?.experience?.length
    "
  ></div>

  <div class="section" *ngIf="data?.summary">
    <h3 [style.color]="color">SUMMARY</h3>
    <p>{{ data.summary }}</p>
  </div>

  <div class="section" *ngIf="data?.education?.length">
    <h3 [style.color]="color">EDUCATION</h3>

    <ng-container *ngFor="let e of data.education">
      <div class="item" *ngIf="e?.collegeName || e?.degree">
        <div class="row">
          <strong *ngIf="e?.collegeName">
            {{ e.collegeName }}
          </strong>

          <span *ngIf="e?.startYear || e?.endYear">
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && (e?.endYear || e?.currently_studying)">
              -
            </span>

            <ng-container *ngIf="e?.currently_studying">Present</ng-container>

            <ng-container *ngIf="!e?.currently_studying">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>

        <p *ngIf="e?.degree || e?.location">
          <ng-container *ngIf="e?.degree">{{ e.degree }}</ng-container>
          <span *ngIf="e?.degree && e?.location">, </span>
          <ng-container *ngIf="e?.location">{{ e.location }}</ng-container>
        </p>

        <p *ngIf="e?.cgpa_or_percentage">CGPA: {{ e.cgpa_or_percentage }}</p>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.projects?.length">
    <h3 [style.color]="color">PROJECTS</h3>

    <ng-container *ngFor="let p of data.projects">
      <div class="item" *ngIf="p?.title || p?.description">
        <strong *ngIf="p?.title">{{ p.title }}</strong>

        <p *ngIf="p?.technologies?.length" class="italic">
          {{ p.technologies.join(", ") }}
        </p>

        <p *ngIf="p?.description">{{ p.description }}</p>

        <p *ngIf="p?.outcome" class="link">↗ {{ p.outcome }}</p>
      </div>
    </ng-container>
  </div>

  <div
    class="section"
    *ngIf="
      data?.skills?.technicalSkills?.length ||
      data?.skills?.tools?.length ||
      data?.skills?.softSkills?.length
    "
  >
    <h3 [style.color]="color">SKILLS</h3>

    <p *ngIf="data?.skills?.technicalSkills?.length">
      <strong>Technical:</strong>
      {{ data.skills.technicalSkills.join(", ") }}
    </p>

    <p *ngIf="data?.skills?.tools?.length">
      <strong>Tools:</strong>
      {{ data.skills.tools.join(", ") }}
    </p>

    <p *ngIf="data?.skills?.softSkills?.length">
      <strong>Soft Skills:</strong>
      {{ data.skills.softSkills.join(", ") }}
    </p>
  </div>

  <div class="section" *ngIf="data?.experience?.length">
    <h3 [style.color]="color">EXPERIENCE</h3>

    <ng-container *ngFor="let e of data.experience">
      <div class="item" *ngIf="e?.role || e?.company">
        <div class="row">
          <strong *ngIf="e?.role">{{ e.role }}</strong>

          <span *ngIf="e?.startYear || e?.endYear || e?.currently_working">
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && (e?.endYear || e?.currently_working)">
              -
            </span>

            <ng-container *ngIf="e?.currently_working">Present</ng-container>

            <ng-container *ngIf="!e?.currently_working">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>

        <p *ngIf="e?.company || e?.location">
          {{ e.company }}
          <span *ngIf="e?.company && e?.location">, </span>
          {{ e.location }}
        </p>

        <p *ngIf="e?.description">{{ e.description }}</p>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.certifications?.length">
    <h3 [style.color]="color">CERTIFICATIONS</h3>

    <ng-container *ngFor="let c of data.extras.certifications">
      <p *ngIf="c?.name || c?.platform || c?.year">
        <span *ngIf="c?.name">• {{ c.name }}</span>

        <span *ngIf="c?.platform || c?.year">
          <span *ngIf="c?.name"> (</span>
          {{ c.platform }}
          <span *ngIf="c?.platform && c?.year"> - </span>
          {{ c.year }}
          <span *ngIf="c?.name">)</span>
        </span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.awards?.length">
    <h3 [style.color]="color">AWARDS</h3>

    <ng-container *ngFor="let a of data.extras.awards">
      <p *ngIf="a?.name">
        • {{ a.name }}

        <span *ngIf="a?.organization"> - {{ a.organization }} </span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.hackathons?.length">
    <h3 [style.color]="color">HACKATHONS</h3>

    <ng-container *ngFor="let h of data.extras.hackathons">
      <p *ngIf="h?.name">
        • {{ h.name }}

        <span *ngIf="h?.rank">({{ h.rank }})</span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.languages?.length">
    <h3 [style.color]="color">LANGUAGES</h3>

    <ng-container *ngFor="let l of data.extras.languages">
      <span *ngIf="l?.name">
        • {{ l.name }}

        <span *ngIf="l?.proficiency"> ({{ l.proficiency }}) </span>
      </span>
    </ng-container>
  </div>
</div>
